import Shapes from './Shapes.js';

export default class {
    constructor(mapObject, customOptions) {
        this.mapObject = mapObject;
        this.mapObject.setOptions({ streetViewControl: false });
        this.drawingManager = new google.maps.drawing.DrawingManager();
        this.drawingManager.setMap(this.mapObject);
        this.drawingManager.setOptions({
            drawingMode: null,
            drawingControl: false,
        });
        this.drawingInitialized = false;
        this.shapesManager = new Shapes();
        this.customOptions = customOptions;

        this.lastShape = null;
        this.shapes = [];
    }

    initializeDrawing() {
        if (this.drawingInitialized) {
            return;
        }

        this.drawingInitialized = true;
        this.drawingManager.setOptions({
            drawingMode: null,
            drawingControl: true,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [
                    google.maps.drawing.OverlayType.RECTANGLE,
                    google.maps.drawing.OverlayType.POLYGON,
                ],
            },
            polylineOptions: {
                strokeColor: 'white',
            },
            rectangleOptions: {
                editable: false,
                draggable: false,
            },
            ... this.customOptions,
        });

        // Set the drawing manager to the map
        this.drawingManager.setMap(this.mapObject);

        return this.drawingManager;
    }

    finishedDrawing(callback) {
        google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {
            // Set this as the latest shape
            this.setLastShape(event.overlay);

            // Callback with the shape
            callback(this.lastShape, event.type);
        });
    }

    resetLastShape() {
        if (this.lastShape) {
            this.lastShape.setMap(null);
        }
    }

    resetShapes(shapes) {
        Object.keys(shapes).forEach((key) => {
            shapes[key].setMap(null);
        });

        this.shapes = [];
    }

    setLastShape(shape) {
        // Set the new shape
        this.lastShape = shape;
    }

    fitToShape(shapeId) {
        if (this.shapes[shapeId]) {
            this.fitToShapes([this.shapes[shapeId]]);
        }
    }

    fitToShapes(shapes) {
        const bounds = new google.maps.LatLngBounds();

        Object.keys(shapes).forEach((key) => {
            const paths = shapes[key].getPaths();

            paths.forEach(function (path) {
                const pathArray = path.getArray();
                for (let i = 0; i < pathArray.length; i++) {
                    bounds.extend(pathArray[i]);
                }
            });
        });

        this.mapObject.fitBounds(bounds);
    }

    addShape(id, groupId, coordinates, editable = false) {
        // Shape already exists, no need to paint it again
        if (this.shapes[id]) {
            return this.shapes[id];
        }

        const polygon = [];
        // Make a polygon from each pair of coordinates
        for (const position of coordinates) {
            polygon.push(new google.maps.LatLng(position[1], position[0]));
        }

        // Create shape out of polygon
        const shape = new google.maps.Polygon({
            id: id,
            groupId: groupId,
            paths: polygon,
            editable,
        });

        // Add to the map
        shape.setMap(this.mapObject);

        // When the shape is clicked, set it as active
        google.maps.event.addDomListener(shape, 'mouseup', () => {
            EventBus.$emit('selected-prospect', shape.groupId);
        });

        google.maps.event.addDomListener(shape, 'mouseover', () => {
            Object.keys(this.shapes).forEach((key) => {
                if (this.shapes[key].groupId === shape.groupId) {
                    this.shapesManager.setBorder(this.shapes[key], '#eb6424');
                }
            });
        });

        google.maps.event.addDomListener(shape, 'mouseout', () => {
            Object.keys(this.shapes).forEach((key) => {
                if (this.shapes[key].groupId === shape.groupId) {
                    this.shapesManager.resetBorder(this.shapes[key]);
                }
            });
        });

        // Remember the shape
        this.shapes[id] = shape;
        this.fitToShapes(this.shapes);

        return shape;
    }

    addMarker(coordinates, options) {
        const shape = new google.maps.Marker({
            position: coordinates,
            ... options,
        });

        shape.setMap(this.mapObject);

        return shape;
    }

    addPolyline(coordinates, options) {
        const shape = new google.maps.Polyline({
            path: coordinates,
            ... options,
        });

        shape.setMap(this.mapObject);

        return shape;
    }
}
